import Axios from "../utils/axios";
import type { IAccountingFees } from "../interfaces/models/IAccountingFees";

const axios = new Axios();

export const getAllAccountingFees = async (): Promise<IAccountingFees[]> => {
  try {
    const response = await axios.Get("/accountingFees");
    return Array.isArray(response.data) ? response.data : [];
  } catch (error) {
    console.error("Error fetching AccountingFees:", error);
    return [];
  }
};

export const getAccountingFeesByYear = async (
  year: number
): Promise<IAccountingFees | null> => {
  try {
    const params = new URLSearchParams();
    params.append(
      "filter",
      JSON.stringify({
        year: { value: year, comparisonType: "EQUAL" },
        type: { value: "normal", comparisonType: "EQUAL" },
      })
    );
    const response = await axios.Get(`/accountingFees?${params.toString()}`);
    const data = response.data;
    if (Array.isArray(data) && data.length > 0) {
      return data[0] as IAccountingFees;
    }
    return null;
  } catch (error) {
    console.error("Error fetching AccountingFees:", error);
    return null;
  }
};

export const updateAccountingFees = async (
  doc: IAccountingFees,
): Promise<IAccountingFees> => {
  const response = await axios.Put("/accountingFees", doc);
  return response.data as IAccountingFees;
};

export const createAccountingFees = async (
  doc: IAccountingFees,
): Promise<IAccountingFees> => {
  const response = await axios.Post("/accountingFees", doc);
  return response.data as IAccountingFees;
};

export const saveFiscalYearFees = async (
  payload: {
    normal?: IAccountingFees;
    createNormal?: IAccountingFees;
  },
): Promise<void> => {
  if (payload.createNormal) {
    await createAccountingFees(payload.createNormal);
  } else if (payload.normal) {
    await updateAccountingFees(payload.normal);
  }
};
